<div class="organization-detail-shell" data-testid="organization-detail-shell">
    <div class="main-content organization-detail-shell__content">
        <header class="top-header organization-detail-shell__header" data-testid="organization-detail-header">
            <h3>{{ organizationName || (loading ? 'Loading organization…' : 'Organization') }}</h3>
            <p *ngIf="organizationId" class="organization-detail-shell__meta">
                Organization ID {{ organizationId }}
                <span *ngIf="organizationActive === true"> · Active</span>
                <span *ngIf="organizationActive === false"> · Inactive</span>
            </p>
            <p *ngIf="loadError" class="organization-detail-shell__error" data-testid="organization-detail-header-error">
                {{ loadError }}
                <button type="button"
                        class="organization-detail-shell__retry"
                        data-testid="organization-detail-retry"
                        (click)="retryLoadOrganization()">
                    Retry
                </button>
            </p>
        </header>

        <nav class="organization-detail-tabs"
             aria-label="Organization sections"
             data-testid="organization-detail-tabs">
            <a *ngFor="let tab of visibleTabs"
               class="organization-detail-tabs__link"
               [routerLink]="['/organization', organizationId, tab.path]"
               queryParamsHandling="preserve"
               routerLinkActive="is-active"
               [routerLinkActiveOptions]="{exact: true}"
               [attr.data-testid]="tab.testId">
                {{ tab.label }}
            </a>
        </nav>

        <div class="organization-detail-shell__outlet">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
